export default "__VITE_ASSET__f01ff6d6__"